import React from 'react';

interface CurrentTimeIndicatorProps {
  now: Date;
  rowHeightPx: number;
}

/**
 * Horizontal line + dot marker that indicates the current time within
 * a calendar hour-row. Render only when the cell belongs to the current hour.
 */
export default function CurrentTimeIndicator({ now, rowHeightPx }: CurrentTimeIndicatorProps) {
  const offset = Math.round((now.getMinutes() / 60) * rowHeightPx);
  return (
    <div style={{ position: 'absolute', left: 0, right: 0, top: offset, height: 0, borderTop: '2.5px solid #dc2626', pointerEvents: 'none', zIndex: 40 }}>
      <div style={{ position: 'absolute', left: -4, top: -5, width: 8, height: 8, borderRadius: '50%', background: '#dc2626' }} />
    </div>
  );
}
